<!-- Side Structure -->
<template>
  <v-navigation-drawer
    :mini-variant.sync="mini"
    v-model="drawer"
    app
    fixed
    class="Vuely-sidebar sidebar-scroll lnbSidebar width-change"
    style="margin-top: -10px; z-index: 9;"
    :class="{ 'width-mini' : mini, 'width-mouse' : (isSmallScreen || (mouseOverLav && !clickOpen)) }"
    width="330"
    ref="drawerRef"
    :right="rtlLayout">
    <div @click.stop="toggleLayout()" class="sidebar_btn" style="display:none;">
      <v-img src="//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/chevron_left.png" aspect-ratio="1"></v-img>
    </div>
    <div class="nav">
      <div class="item">
        <ul @mouseleave="mouseOut()">
          <li v-for="(category, mainKey) in menuData" :key="mainKey" class="unfold" :class="{on: checkMenu(category.id, mainKey)}">
            <v-btn class="size" @mouseenter="mouseOver()" @click="fadeSide()" flat icon :to="category.path" :disabled="checkMenuDis()">
              <i :class="category.icon"></i>
              <div>
                <span class="leftSpace" v-if="(mouseOverLav && clickOpen) || mini">{{ textTruncate(category.title) }}</span>
              </div>
            </v-btn>
            <div class="subItem" v-if="(category.children && !mouseOverLav)" >
              <vue-perfect-scrollbar class="scroll-area" :settings="settings" id="perfect-scrollbar">
                <div v-for="(subItem, subKey) in category.children" :key="subKey" class="subItemList">
                  <p class="tit">{{ textTruncate(subItem.title) }}</p>
                  <ol>
                    <li v-for="(lists, key) in subItem.children" :key="key" :class="{on: $route.path === lists.path || subDepCheck(lists.pages)}" v-if="lists.path">
                      <v-btn v-if="lists.path.indexOf('http://') === -1 && lists.path.indexOf('https://') === -1" flat :to="lists.path" :disabled="checkMenuDis(lists)">
                        <span class="txt">{{ textTruncate(lists.title) }}</span>
                      </v-btn>
                      <v-btn v-else flat :href="lists.path" target="_blank" class="iconBtn">
                        <span class="txt">{{ textTruncate(lists.title) }}<i class="UXicon-new_window"></i></span>
                      </v-btn>
                    </li>
                  </ol>
                </div>
              </vue-perfect-scrollbar>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import UserBlock from '../header/fragments/user_block'
import helper from 'util/helpers'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Util from '@/util'
import wsConn from '@/util/wsConnection'

export default {
  mixins: [wsConn],
  created () {
    this.brandId = this.agentMappingBrandViews.sort((left, right) => left.brandId - right.brandId)[0].brandId
    this.checkUseCall()
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 160
      },
      mini: false,
      horizontal: false,
      useBrand: 0,
      brandId: '',
      menuData: [],
      recentCountEffectCalledTime: null,
      drawer: true,
      mouseOverLav: false,
      clickOpen: false,
      isSmallScreen: window.innerWidth <= 1024
    }
  },
  components: {
    UserBlock
  },
  computed: {
    ...mapGetters([
      'rtlLayout',
      'collapseSidebar',
      'isAdministratorRole',
      'ticketAgentId',
      'isMobileSize',
      'agentMappingBrandViews',
      'getCheckPaths',
      'getAgentMenu',
      'planType'
    ])
  },
  watch: {
    getAgentMenu () {
      this.menuData = this.getMenus()
    }
  },
  mounted () {
    this.notification()
    this.menuData = this.getMenus()
    if (this.ticketAgentId && !this.isAdministratorRole) {
      this.connectTicket()
    } else if (this.isAdministratorRole) {
      this.menuData = this.getMenus()
    }
    this.$eventBus.$on('TRIGGER_DRAWER_HANDLER', () => {
      let status = this.$refs.drawerRef.isActive
      this.drawer = !status
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    mainDepCheck (data) {
      let toPath = this.$route.path
      if (Object.keys(this.$route.params).length > 0) {
        toPath = Util.pathReplace(this.$route.params, toPath)
      }
      return data.indexOf(toPath) > -1
    },
    subDepCheck (data) {
      if (data) {
        let toPath = Util.pathReplace(this.$route.params, this.$route.path)
        return data.find((p) => p.path === toPath)
      }
      return false
    },
    sideBarScrollTop () {
      if (this.isMobileSize) {
        document.querySelector('#perfect-scrollbar').scrollTop = 0
      }
    },
    toggleLayout () {
      this.mini = !this.mini
      this.$store.dispatch('setMiniSidebarLayout', this.mini)
    },
    textTruncate (text) {
      return helper.textTruncate(text, 18)
    },
    getCurrentAppLayoutHandler () {
      return helper.getCurrentAppLayout(this.$router)
    },
    getMenus: function () {
      let menus = JSON.parse(localStorage.getItem('agent-menus'))
      return menus
    },
    defaultSelected (item) {
      if (this.ticketAgentId && this.useBrand > 0) {
        return item.title === 'チケット管理'
      }
    },
    makeCountShort (count) {
      if (!count) {
        return '-'
      } else {
        let tmp = count.toString()
        if (tmp.length > 3) {
          return `${Math.floor(count / 1000)}k`
        } else {
          return count
        }
      }
    },
    // TODO 추후에 깜빡거림이 거슬린다는 문의가 들어왔을때 사용할 것.
    checkTimeIsOver (newDate, oldDate) {
      // 깜빡거리는 이펙트에 대한 쿨다운 함수
      if (!oldDate) {
        this.recentCountEffectCalledTime = newDate
        return true
      }
      let diffTime = moment(newDate, 'YYYYMMDDHHmmSS').diff(moment(oldDate, 'YYYYMMDDHHmmSS'))
      let duration = moment.duration(diffTime)
      let seconds = Math.floor(duration.asSeconds())
      if (seconds >= 5) {
        this.recentCountEffectCalledTime = newDate
        return true
      } else {
        return false
      }
    },
    notification () {
      if (!('Notification' in window)) {
        console.log('このブラウザは通知をサポートしていません.')
      } else {
        if (window.Notification) {
          Notification.requestPermission()
        }
      }
    },
    topNewMenuCheck (item) {
      return item.title === '顧客管理' || item.title === '相談の設定'
    },
    checkMenu (id, index) {
      const isActive = this.getCheckPaths[id] && this.mainDepCheck(this.getCheckPaths[id])
      if (isActive && this.getMenus()) {
        this.menuNum = index
        this.mini = !(this.getMenus()[this.menuNum]).children
        this.$store.dispatch('setMiniSidebarLayout', this.mini)
      }
      return isActive
    },
    handleResize () {
      this.isSmallScreen = window.innerWidth <= 1024
    },
    mouseOver () {
      if (this.isSmallScreen) {
        this.mouseOverLav = true
        this.clickOpen = false
      } else {
        let sidebarWidth = document.querySelector('.sidebar-scroll').offsetWidth
        let eventOnWidth = [330, 70, 280]
        if (eventOnWidth.indexOf(sidebarWidth) !== -1) {
          this.mouseOverLav = true
          this.clickOpen = !this.mini
        }
      }
    },
    mouseOut () {
      if (!this.isSmallScreen) {
        this.mouseOverLav = false
        this.clickOpen = true
      }
    },
    fadeSide () {
      this.mouseOverLav = false
      if (this.mini) {
        this.clickOpen = true
      } else {
        this.clickOpen = false
      }
    },
    checkMenuDis (data) {
      if (Util.parseLoginToken()) {
        let isAdmin = Util.parseLoginToken().admin ? Util.parseLoginToken().admin : null
        let isPause = JSON.parse(localStorage.getItem('isPause'))
        let lookInBrandResult = localStorage.getItem('lookInBrandResult')
        if (isAdmin || lookInBrandResult) {
          return false
        } else {
          if (isPause) {
            if (data) {
              return !(data.path === '/brand/plan')
            }
            return true
          } else {
            return false
          }
        }
      }
    }
  }
}
</script>

<style>
  .sidebar_btn {
    width: 35px;
    height: 35px;
    cursor: pointer;
    margin: 12px 0 10px 17px;
  }

  .sidebar-scroll {
    max-height: calc(100% - 53px) !important;
    margin-bottom: 10px !important;
  }

  .tk-count-num{
    text-align: right;
    color: #1C5BBC;
    font-weight: 600;
    padding-right: 20px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.7s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .unfold {
    width: 200px !important;
    text-align: left !important;
    font-size: 14px;
    font-weight: 700;
  }
  .width-mini {
    width: 70px !important;
  }
  .width-mouse {
    width: 280px !important;
  }
  .leftSpace {
    margin-left: 30px
  }
  .size {
    width: auto;
  }
  .size > .v-btn__content {
    justify-content:flex-start!important;
  }
  @media screen and (max-width: 1024px) {
    .width-mouse {
      width: 330px !important;
    }
    .v-navigation-drawer--close {
      transform: translateX(-330px) !important;
    }
  }
  @media screen and (max-width: 600px) {
    .sidebar_btn {
      display: none;
    }
    .sidebar{
      padding-top: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/templates/sidebar/sidebar.vue